import { buildComponent } from '#components'

const AppComponent = buildComponent({
  name: 'app-component',
  onConnected: (component) => {
    const observer = new MutationObserver(() => {
      const reviewEl = component.querySelector('#stamped-reviews-widget') as HTMLElement
      const reviewLinks = reviewEl && reviewEl.querySelectorAll('a.stamped-reviews-link')

      if (reviewLinks && reviewLinks.length > 0) {
        reviewLinks.forEach((link, index) => {
          if (!link.hasAttribute('aria-label')) {
            const label = link.innerHTML ? link.innerHTML : `review item ${index + 1}`

            link.setAttribute('aria-label', label)
          }
        })
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'app-component': typeof AppComponent
  }
}
